<template>
  <div v-if="selectedPaymentMethod">
    <ErrorBoundary :owners="['bot-squad-payin-front']">
      <InstallmentSimulation
        :base-price="priceAfterDiscount"
        data-qa="installments"
        :payment-method="selectedPaymentMethod"
      >
        <template #installments="{ isLoading, simulation }">
          <Installments
            :is-loading
            :selected-payment-method
            :simulation
            :total-title
          />
        </template>
        <template #fallback>
          <div>
            <RevDivider class="my-16" />

            <TotalAmount
              :price-after-discount
              :total-price-after-buyback
              :total-title
              :with-swap
            />
          </div>
        </template>
      </InstallmentSimulation>
    </ErrorBoundary>
  </div>

  <div v-if="!selectedPaymentMethod">
    <RevDivider class="my-16" />

    <TotalAmount
      :price-after-discount
      :total-price-after-buyback
      :total-title
      :with-swap
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { MonetaryAmount } from '@backmarket/http-api'
import type { PaymentMethod } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'
import type { CartItem } from '@backmarket/nuxt-layer-checkout/api/cart/types'
import InstallmentSimulation from '@backmarket/nuxt-layer-payment/advertising/components/InstallmentSimulation/InstallmentSimulation.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import ErrorBoundary from '@backmarket/nuxt-module-logger/components/ErrorBoundary.vue'
import { RevDivider } from '@ds/components/Divider'

import translations from './Totals.translations'
import Installments from './components/Installments/Installments.vue'
import TotalAmount from './components/TotalAmount/TotalAmount.vue'

const i18n = useI18n()

const props = withDefaults(
  defineProps<{
    items: CartItem[]
    priceAfterDiscount: MonetaryAmount
    selectedPaymentMethod?: PaymentMethod | null
    totalPriceAfterBuyback?: MonetaryAmount
    withSwap: boolean
    withTax: boolean
  }>(),
  {
    selectedPaymentMethod: undefined,
    totalPriceAfterBuyback: undefined,
  },
)

const withMobilePlan = computed(() =>
  props.items.some((item) => item.mobilePlan?.selectedOffer?.type === 'ONLINE'),
)

const totalTitle = computed(() => {
  if (props.withSwap || withMobilePlan.value) {
    return i18n(translations.totalDueToday)
  }

  return props.withTax
    ? i18n(translations.total)
    : i18n(translations.totalWithTaxes)
})
</script>
